/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemDependencySchema } from './itemDependencySchema';

export const itemResponseSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  customFields: z
    .object({})
    .catchall(z.any())
    .describe(
      'Custom field values keyed by field id. Each value object is tagged with the field type name (e.g. `LINK`) alongside `fieldType`; multi-value fields are arrays.',
    )
    .nullish(),
  deadlineDateTime: z.iso.datetime().nullish(),
  get dependencies() {
    return z.array(itemDependencySchema).nullish();
  },
  description: z.string().nullish(),
  doneDateTime: z.iso.datetime().nullish(),
  earliestStartDateTime: z.iso.datetime().nullish(),
  estimationId: z.int().nullish(),
  externalCreatedAt: z.iso.datetime().nullish(),
  externalKey: z.string().nullish(),
  externalLink: z.string().nullish(),
  id: z.int(),
  itemStatusId: z.int(),
  itemTypeId: z.int(),
  loopId: z.int(),
  name: z.string(),
  parentId: z.int().nullish(),
  parentManagedByIntegration: z.boolean(),
  plannedFinishDateTime: z.iso.datetime().nullish(),
  plannedStartDateTime: z.iso.datetime().nullish(),
  priority: z.string(),
  schedulingType: z.enum(['ACTUALS_ONLY', 'PLANNED_AND_ACTUALS']),
  teamId: z.int().nullish(),
  timeSpentSeconds: z.int().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
